import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  modalRef: NgbModalRef

  constructor(private toastrService: ToastrService, private router: Router, private modalService: NgbModal) {}

  showMessage(statusCode: number, msg: any, action: string, redirectUrl?: string) {
    const toastrActions: any = {
      create: this.toastrService.success,
      update: this.toastrService.success,
      delete: this.toastrService.success,
      read: this.toastrService.success,
      info: this.toastrService.info,
    };

    if (statusCode >= 400) {
      if(statusCode == 500) {
        this.toastrService.error(`${msg} - Ocorreu um erro ao fazer a chamada, por favor tente mais tarde!`, 'PTA - Portal de Transferência de Arquivos');
      } else {
        this.handleError(msg);
      }

    } else {
      const toastrAction = toastrActions[action];
      if (toastrAction) {
        toastrAction.call(this.toastrService, msg, 'PTA - Portal de Transferência de Arquivos');
      } else {
        this.toastrService.error(msg, 'PTA - Portal de Transferência de Arquivos');
      }

      if (redirectUrl) {
        this.router.navigateByUrl(redirectUrl);
      } else {
        this.router.navigateByUrl('/');
      }
    }
  }

  private handleError(msg: any) {
    this.toastrService.error(`${msg}`, 'PTA - Portal de Transferência de Arquivos');
  }
}
